<template>
  <component
    v-if="currentComponent"
    :is="currentComponent"
  />
</template>

<script>
import OrderBot from "@/views/bots/views/Order.vue";
import TailoringOrderBotPage from "@/views/bots/views/TailoringOrder.vue";

export default {
  name: "OrderBotRouter",
  components: {
    OrderBot,
    TailoringOrderBotPage,
  },
  data() {
    return {
      orderFulfillmentKind: this.$route.query.fulfillmentKind || null,
    };
  },
  computed: {
    currentComponent() {
      if (!this.orderFulfillmentKind) {
        return null;
      }

      return this.orderFulfillmentKind === "Tailoring"
        ? "TailoringOrderBotPage"
        : "OrderBot";
    },
  },
  watch: {
    "$route.fullPath": {
      handler() {
        this.resolveOrderKind();
      },
      immediate: true,
    },
  },
  methods: {
    async resolveOrderKind() {
      const routeFulfillmentKind = this.$route.query.fulfillmentKind;
      const routeKind = this.$route.params.kind || this.$route.query.kind;

      if (routeFulfillmentKind) {
        this.orderFulfillmentKind = routeFulfillmentKind;
        return;
      }

      if (routeKind) {
        this.orderFulfillmentKind = "Standard";
        return;
      }

      const id = this.$route.params.id;
      if (!id) {
        this.orderFulfillmentKind = "Standard";
        return;
      }

      const response = await this.$store.dispatch("getFilter", {
        table: "Order",
        body: { id, rootColumn: "Id" },
      });
      const order = response.data.data?.[0];
      this.orderFulfillmentKind = order?.fulfillmentKind || "Standard";
    },
  },
};
</script>
